const RahuKaalMain: React.FC = () => <Outlet />;
export default RahuKaalMain;
